import React from 'react';
import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import { LinkContainer } from 'react-router-bootstrap';
import LogoutLinkContainer from '../common/LogoutLinkContainer';
import PtSearch from '../common/PtSearch';
import { useAuthContext } from '../hooks/useAuth';
export default function AuthedNavbarContent({ logout, search }) {
  const userObject = useAuthContext();
  const is_admin = userObject?.user?.username === 'admin';
  return (
    <>
      <ButtonToolbar className="custom-btn-toolbar mr-auto">
        <LinkContainer className="mr-4" to="/">
          <img
            className="logo"
            src="/HADI-logo.png"
            alt="HADI - Headache Data Insight"
            width="140"
            height="90"
          ></img>
        </LinkContainer>
        {is_admin && (
          <LinkContainer to="/newclinic">
            <Button variant="secondary">Add Clinic</Button>
          </LinkContainer>
        )}
        <LinkContainer to="/newpatient">
          <Button variant="secondary">New Patient</Button>
        </LinkContainer>
      </ButtonToolbar>
      <LogoutLinkContainer variant="outline-secondary" logout={logout} />
      <PtSearch search={search} />
    </>
  );
}
